import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toggleFavorite } from '../actions/favorites';
import { enqueueNotification } from '../actions/notifications';
import { getDisplayName } from '../helpers/common';

const mapStateToProps = (state, ownProps) => ({
  isFavorite: state.favorites && state.favorites.includes(ownProps.id),
});
const mapDispatchToProps = {
  toggleFavorite,
  enqueueNotification,
};

const withFavorite = WrappedComponent =>
  connect(mapStateToProps, mapDispatchToProps)(
    class extends React.Component {
      static displayName = `withFavorite(${getDisplayName(WrappedComponent)})`;

      static propTypes = {
        toggleFavorite: PropTypes.func.isRequired,
        enqueueNotification: PropTypes.func.isRequired,
        isFavorite: PropTypes.bool,
      };
      static defaultProps = {
        isFavorite: false,
      };

      state = {
        isLoading: false,
      };

      handleToggleFavorite = id => {
        this.setState({ isLoading: true });

        this.props
          .toggleFavorite(id)
          .then(() => {})
          .catch(error => this.props.enqueueNotification(error.message))
          .then(
            () => this.setState({ isLoading: false }),
            () => this.setState({ isLoading: false }),
          );
      };

      render() {
        const { isFavorite, ...props } = this.props;

        return (
          <div>
            <WrappedComponent
              {...props}
              isLoading={this.state.isLoading}
              toggleFavorite={this.handleToggleFavorite}
              isFavorite={isFavorite}
            />
          </div>
        );
      }
    },
  );

export default withFavorite;



// WEBPACK FOOTER //
// ./src/shared/hocs/withFavorite.js